// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1FW3j","content":"styles_content__31uCO"};